// Data for dropdowns
export const COUNTRIES = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Argentina", "Armenia", "Australia",
  "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium",
  "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei",
  "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde",
  "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica",
  "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic",
  "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia",
  "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada",
  "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "India",
  "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Ivory Coast", "Jamaica", "Japan", "Jordan",
  "Kazakhstan", "Kenya", "Kiribati", "North Korea", "South Korea", "Kosovo", "Kuwait", "Kyrgyzstan",
  "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg",
  "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands",
  "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro",
  "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand",
  "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea",
  "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda",
  "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent", "Samoa", "San Marino", "Saudi Arabia",
  "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia",
  "Solomon Islands", "Somalia", "South Africa", "South Sudan", "Spain", "Sri Lanka", "Sudan",
  "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania",
  "Thailand", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu",
  "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay",
  "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
];

export const LANGUAGES = [
  "Afrikaans", "Albanian", "Amharic", "Arabic", "Armenian", "Azerbaijani", "Basque", "Belarusian",
  "Bengali", "Bosnian", "Bulgarian", "Burmese", "Catalan", "Cebuano", "Chinese (Cantonese)",
  "Chinese (Mandarin)", "Croatian", "Czech", "Danish", "Dutch", "English", "Estonian", "Farsi",
  "Filipino", "Finnish", "French", "Galician", "Georgian", "German", "Greek", "Gujarati",
  "Haitian Creole", "Hausa", "Hebrew", "Hindi", "Hungarian", "Icelandic", "Igbo", "Indonesian",
  "Irish", "Italian", "Japanese", "Javanese", "Kannada", "Kazakh", "Khmer", "Korean", "Kurdish",
  "Kyrgyz", "Lao", "Latvian", "Lithuanian", "Luxembourgish", "Macedonian", "Malay", "Malayalam",
  "Maltese", "Maori", "Marathi", "Mongolian", "Nepali", "Norwegian", "Oriya", "Pashto", "Polish",
  "Portuguese", "Punjabi", "Romanian", "Russian", "Samoan", "Serbian", "Shona", "Sindhi",
  "Sinhala", "Slovak", "Slovenian", "Somali", "Spanish", "Sundanese", "Swahili", "Swedish",
  "Tajik", "Tamil", "Telugu", "Thai", "Turkish", "Ukrainian", "Urdu", "Uzbek", "Vietnamese",
  "Welsh", "Xhosa", "Yiddish", "Yoruba", "Zulu"
];

export const CANADIAN_PROVINCES = [
  "Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador",
  "Northwest Territories", "Nova Scotia", "Nunavut", "Ontario", "Prince Edward Island",
  "Quebec", "Saskatchewan", "Yukon"
];

export const CANADIAN_CITIES = {
  "British Columbia": ["Vancouver", "Victoria", "Surrey", "Burnaby", "Richmond", "Langley", "Abbotsford", "Coquitlam", "Kelowna", "Nanaimo"],
  "Alberta": ["Calgary", "Edmonton", "Red Deer", "Lethbridge", "Medicine Hat"],
  "Ontario": ["Toronto", "Ottawa", "Mississauga", "Brampton", "Hamilton", "London", "Windsor", "Kitchener"],
  "Quebec": ["Montreal", "Quebec City", "Laval", "Gatineau", "Longueuil"],
  "Manitoba": ["Winnipeg", "Brandon", "Steinbach"],
  "Saskatchewan": ["Regina", "Saskatoon", "Prince Albert"],
  "Nova Scotia": ["Halifax", "Dartmouth", "Sydney"],
  "New Brunswick": ["Saint John", "Moncton", "Fredericton"],
  "Newfoundland and Labrador": ["St. John's", "Corner Brook", "Mount Pearl"],
  "Prince Edward Island": ["Charlottetown", "Summerside"],
  "Northwest Territories": ["Yellowknife", "Hay River"],
  "Yukon": ["Whitehorse", "Dawson City"],
  "Nunavut": ["Iqaluit", "Rankin Inlet"]
};

export const GENDERS = ["Male", "Female", "Non-binary", "Prefer not to say"];

export const TEST_TYPES = [
  { value: "itep", label: "iTEP Academic-Plus Test" },
  { value: "duolingo", label: "Duolingo English Test" }
];

export const TEST_PACKAGES = {
  itep: { name: "iTEP Academic-Plus Test", price: 200.00, tax: 26.00 },
  duolingo: { name: "Duolingo English Test", price: 95.00, tax: 12.35 },
  prep_package: { name: "Test Preparation Package", price: 1000.00, tax: 130.00 }
};

export const TERMS_AND_CONDITIONS = `
<h2>Terms and Conditions</h2>
<p><strong>English Test Solution - Test Preparation Services</strong></p>
<p>Last Updated: January 2026</p>

<h3>1. Services Overview</h3>
<p>English Test Solution provides test preparation services for iTEP Academic-Plus and Duolingo English Tests. Our services include preparation materials, practice tests, and test booking assistance at our authorized test centers in Langley and Surrey, British Columbia, Canada.</p>

<h3>2. Test Fees and Packages</h3>
<ul>
<li><strong>iTEP Academic-Plus Test:</strong> C$200 + applicable taxes</li>
<li><strong>Duolingo English Test:</strong> C$95 + applicable taxes</li>
<li><strong>Test Preparation Package:</strong> C$1,000 + applicable taxes</li>
</ul>

<h3>3. Refund Policy</h3>
<p><strong>Test Preparation Package Refund Guarantee:</strong></p>
<ul>
<li>If a student does not clear their test after completing our preparation program, the Test Preparation Package fee is refundable.</li>
<li>An administrative fee of <strong>C$50</strong> will be deducted from all refunds.</li>
<li>Refund requests must be submitted within 30 days of receiving test results.</li>
<li>Proof of test failure (official score report) is required for refund processing.</li>
<li>The student must have completed at least 80% of the preparation program to be eligible for refund.</li>
</ul>

<p><strong>Test Booking Fees:</strong></p>
<ul>
<li>Test booking fees (iTEP/Duolingo) are non-refundable once the booking is confirmed.</li>
<li>Rescheduling requests must be made at least 48 hours before the scheduled test time.</li>
</ul>

<h3>4. Test Center Requirements</h3>
<ul>
<li>Tests must be taken in person at our authorized test centers in Langley or Surrey, BC.</li>
<li>Valid government-issued photo identification is required.</li>
<li>Students must arrive at least 15 minutes before their scheduled test time.</li>
<li>Late arrivals may result in forfeiture of the test appointment and fees.</li>
</ul>

<h3>5. Booking and Scheduling</h3>
<ul>
<li>All bookings are subject to availability and require admin approval.</li>
<li>Booking confirmations will be sent via email within 12 hours of submission.</li>
<li>Test appointments may be rescheduled subject to availability and rescheduling policies.</li>
</ul>

<h3>6. Test Center Hours</h3>
<ul>
<li><strong>Weekdays:</strong> 2:00 PM - 4:00 PM and 8:00 PM - 9:00 PM</li>
<li><strong>Weekends:</strong> 8:00 AM - 8:00 PM</li>
</ul>

<h3>7. Privacy Policy</h3>
<p>We collect and process personal information in accordance with Canadian privacy laws. Your information will be used solely for test registration, preparation services, and communication purposes. We do not sell or share your personal information with third parties except as required by law or for test administration purposes.</p>

<h3>8. Cancellation Policy</h3>
<ul>
<li>Cancellation requests must be submitted in writing to info@englishtestsolution.com.</li>
<li>Cancellations made more than 48 hours before the test: Full refund minus C$50 admin fee.</li>
<li>Cancellations made within 48 hours: No refund.</li>
<li>No-shows: No refund.</li>
</ul>

<h3>9. Liability</h3>
<p>English Test Solution is not responsible for test results, technical issues during official tests administered by third-party testing organizations, or any consequential damages resulting from test performance.</p>

<h3>10. Contact Information</h3>
<p>English Test Solution<br/>
Email: info@englishtestsolution.com<br/>
Test Centers: Langley & Surrey, BC, Canada</p>

<p><em>By proceeding with registration, you acknowledge that you have read, understood, and agree to these Terms and Conditions.</em></p>
`;
